// services/impressaoService.js
export const impressaoService = {
    /**
     * Gera e imprime o recibo preservando a formatação HTML
     */
    gerarReciboPautaJornalistica(textoRecibo) {
        return new Promise((resolve, reject) => {
            try {
                console.log('ImpressaoService recebeu HTML formatado')
                
                // Cria iframe oculto
                const iframe = document.createElement('iframe')
                iframe.style.position = 'absolute'
                iframe.style.width = '0'
                iframe.style.height = '0'
                iframe.style.border = 'none'
                iframe.style.visibility = 'hidden'
                
                document.body.appendChild(iframe)
                
                // Prepara o HTML completo com CSS melhorado
                const htmlCompleto = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <style>
                            body {
                                font-family: 'Arial', sans-serif;
                                padding: 20px;
                                max-width: 800px;
                                margin: 0 auto;
                                line-height: 1.6;
                                color: #333;
                            }
                            .recibo-container {
                                background: white;
                                padding: 20px;
                            }
                            h2 {
                                color: #000;
                                font-size: 20px;
                                margin: 5px 0;
                                text-transform: uppercase;
                            }
                            h3 {
                                color: #444;
                                font-size: 16px;
                                margin: 5px 0 20px;
                            }
                            p {
                                margin: 8px 0;
                                font-size: 14px;
                            }
                            strong {
                                color: #000;
                                font-weight: 600;
                            }
                            ul {
                                margin: 10px 0;
                                padding-left: 20px;
                            }
                            li {
                                margin: 3px 0;
                                font-size: 13px;
                            }
                            .assinatura {
                                margin-top: 50px;
                            }
                            .linha-assinatura {
                                border-top: 1px solid #000;
                                width: 250px;
                                margin-left: auto;
                                padding-top: 5px;
                            }
                            @media print {
                                body {
                                    padding: 0;
                                    margin: 0;
                                }
                                .recibo-container {
                                    padding: 10px;
                                }
                            }
                        </style>
                    </head>
                    <body>
                        <div class="recibo-container">
                            ${textoRecibo}  <!-- SEU HTML É INSERIDO AQUI -->
                        </div>
                        
                        <script>
                            // Aguarda carregamento completo e imprime
                            window.onload = function() {
                                setTimeout(function() {
                                    window.print();
                                    
                                    // Remove o iframe após impressão
                                    window.onafterprint = function() {
                                        setTimeout(function() {
                                            window.parent.document.body.removeChild(window.frameElement);
                                        }, 500);
                                    };
                                }, 300);
                            };
                        <\/script>
                    </body>
                </html>
                `
                
                // Escreve o HTML completo no iframe
                const iframeDoc = iframe.contentWindow.document
                iframeDoc.open()
                iframeDoc.write(htmlCompleto)
                iframeDoc.close()
                
                resolve({ 
                    sucesso: true, 
                    mensagem: 'Recibo enviado para impressão' 
                })
                
            } catch (error) {
                console.error('❌ Erro na impressão:', error)
                
                reject({ 
                    sucesso: false, 
                    mensagem: error.message 
                })
            }
        })
    },

    /**
     * Versão alternativa com mais controle
     */
    gerarReciboPautaJornalisticaComFallback(textoRecibo) {
        try {
            // Tenta primeiro com iframe
            return this.gerarReciboPautaJornalistica(textoRecibo)
        } catch (error) {
            console.warn('Fallback: tentando método alternativo')
            
            // Fallback: janela pequena
            try {
                const janela = window.open('', '_blank', 'width=600,height=400')
                if (janela) {
                    janela.document.write(`
                        <html>
                        <head>
                            <title>Recibo</title>
                            <style>
                                body { font-family: Arial; padding: 20px; }
                            </style>
                        </head>
                        <body>
                            ${textoRecibo}
                            <script>window.onload = () => window.print()<\/script>
                        </body>
                        </html>
                    `)
                    janela.document.close()
                    
                    return Promise.resolve({ 
                        sucesso: true, 
                        mensagem: 'Impressão iniciada (fallback)' 
                    })
                }
            } catch (fallbackError) {
                return Promise.reject({ 
                    sucesso: false, 
                    mensagem: 'Falha na impressão' 
                })
            }
        }
    }
}